import imageUpload from '../../assets/icons/plus.png';
import '../../assets/styles/pages.scss'
import { Link, useMatch, useNavigate } from 'react-router-dom'
import { Fragment, useContext, useEffect, useState } from 'react';
import henceforthApi from '../../utils/henceforthApi';
import { GlobalContext, handleError } from '../../context/Provider';
import Spinner from '../../components/common/spinner';
import { documentId, formValidate, NumberValidation } from '../../utils/validations';
import Errormessage from '../../components/common/errormessage';
import BreadCrumb from '../../components/common/BreadCrumb';
import { editBrandListing, editProductData, subLists, VariantData } from './productInterface';
import Input, { SaveCancelButton } from '../../components/common/Inputs';
import Select from '../../components/common/Select';
import commonArray from '../../components/common/commonArray';
import Textarea from '../../components/common/Textarea';
import Inputs from '../../components/common/Inputs';
import { toast } from 'react-toastify';


const EditProduct = () => {
    const { authState, authDispatch, language_data, loading, setLoading, toastMessage } = useContext(GlobalContext);
    const match = useMatch('/product/:id/edit')
    const navigate = useNavigate()

    let breadCrumbPath = [
        { name: ` ${language_data?.[authState.lang]?.common_home}`, url: `/`, active: '' },
        { name: `${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_list}`, url: `/products/1`, active: '' },
        { name: `${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_deatil}`, url: `/product/${match?.params.id}`, active: '' },
        { name: `${language_data?.[authState.lang]?.common_edit} ${language_data?.[authState.lang]?.common_product}`, url: ``, active: 'not-allowed' }
    ]



    const [nameErr, setNameErr] = useState<string>("")
    const [brandErr, setBrandErr] = useState<string>("")
    const [priceErr, setPriceErr] = useState<string>("")
    const [taxErr, setTaxErr] = useState<string>("")
    const [categoryErr, setCategoryErr] = useState<string>("")
    const [quantityErr, setQuantityErr] = useState<string>("")
    const [pageLoading, setPageLoading] = useState<boolean>(false)
    const [descriptionErr, setDescriptionErr] = useState<string>("")
    const [subCategoryErr, setSubcategoryErr] = useState<string>("")
    const [selectedFileErr, setSelectedFileErr] = useState<string>('')
    const [subCategory, setSubCategory] = useState<Array<subLists>>([])
    const [subSubCategory, setSubSubCategory] = useState<Array<subLists>>([])
    const [selectedFile, setSelectedFile] = useState<Array<Blob | MediaSource>>([])
    const [variant, setVariant] = useState<VariantData>({
        variant_type: '',
        color: '#000000',
        color_name: '',
        label: '',
        value: ''
    });
    const [brandDetails, setBrandDetails] = useState({
        brand: [],
        category: [],
    } as editBrandListing)
    // parcel: [],
    const [editProduct, setEditProduct] = useState({
        name: '',
        description: '',
        brand_id: '',
        category_id: '',
        subcategory_id: '',
        sub_subcategory_id: '',
        images: [],
        tax_percentage: '',
        quantity: '',
        price: '',
        discount_percantage: '',
        sold: false,
        is_blocked: false,
        is_deleted: false,
        language: ''
    } as editProductData);
    const brandListing = async () => {
        try {
            let apiBrandRes = (await henceforthApi.categorylisting.Brandlisting()).data.data;
            let apiCategoryRes = (await henceforthApi.categorylisting.categorylisting()).data.data;
            setBrandDetails({
                ...brandDetails,
                brand: apiBrandRes,
                category: apiCategoryRes,
            });
        } catch (err) {
            handleError(err, '', authDispatch);
            console.log(err);
        }
    };
    useEffect(() => {
        brandListing();
    }, []);
    const subListing = async () => {
        try {
            let apiSubCategoryRes = (await henceforthApi.categorylisting.subCategorylisting(editProduct.category_id
            )).data.data;
            setSubCategory(apiSubCategoryRes)
        } catch (err) {
            handleError(err, '', authDispatch);
            console.log(err);

        }
    }
    const sub_subListing = async () => {
        let apiSubSubCategoryRes = (await henceforthApi.categorylisting.subSubCategorylisting(editProduct.subcategory_id)).data.data;

        setSubSubCategory(apiSubSubCategoryRes)
    }
    useEffect(() => {
        if ((editProduct.category_id ?? '') !== "") {
            subListing()
        }
    }, [editProduct.category_id])
    useEffect(() => {
        if ((editProduct.subcategory_id ?? '') !== "") {
            sub_subListing()
        }
    }, [editProduct.subcategory_id])
    const handleFile = async (e: any) => {
        let files = e.target.files as Array<Blob | MediaSource>
        setSelectedFile([...selectedFile, ...files])
        e.target.value = ""
    };
    const clearInputErr = (name: string) => {
        if (name === 'name') setNameErr('')
        if (name === 'description') setDescriptionErr('')
        if (name === 'brand_id') setBrandErr('')
        if (name === 'category_id') setCategoryErr('')
        // if (name === 'category_id'&& categoryErr) setEditProduct((editProduct) => {return {...editProduct,subcategory_id: '',}});
        if (name === 'subcategory_id') setSubcategoryErr('')
        // if (name === 'subcategory_id' && subCategoryErr) setEditProduct((editProduct) => {return {...editProduct,subcategory_id: '',}});
        // if (name === 'subcategory_id') setCategoryErr('')
        if (name === 'tax_percentage') setTaxErr('')
        if (name === 'quantity') setQuantityErr('')
        if (name === 'price') setPriceErr('')
    }
    const handleChange = (e: any) => {
        let name = e.target.name;
        let value = e.target.value;
        // PRODUCT NAME LIMIT (95 chars)
        if (name === "name") {
            value = value.slice(0, 95);
        }
        // PRICE LIMIT (15 digits)
        if (name === "price") {
            value = value.slice(0, 15);
        }
        // TAX (0–100 only)
        if (name === "tax_percentage") {
            value = value.replace(/[^0-9]/g, "");
            if (Number(value) > 100) value = "100";
        }

        // QUANTITY (20 digits)
        if (name === "quantity") {
            value = value.replace(/[^0-9]/g, "");
            value = value.slice(0, 20);
        }
        // DISCOUNT (0–100 only)
        if (name === "discount_percantage") {
            value = value.replace(/[^0-9]/g, "");
            if (Number(value) > 100) value = "100";
        }
        clearInputErr(name)
        let res = formValidate(name, value)
        if (res === false) return
        if (name === 'category_id' && !value) setEditProduct((editProduct) => { return { ...editProduct, subcategory_id: '', sub_subcategory_id: '' } });
        if (name === 'subcategory_id' && !value) setEditProduct((editProduct) => { return { ...editProduct, sub_subcategory_id: '', } });
        setEditProduct((editProduct) => {
            return {
                ...editProduct,
                [name]: value,
            }
        });
    };
    const uploadImages = async () => {
        const images = [] as Array<string>
        await Promise.all(selectedFile.map(async (res) => {
            try {
                const apiRes = await henceforthApi.Common.do_spaces_file_upload(`file`, res)
                const data = apiRes.data
                images.push(data.file_name)
            } catch (err) {
                handleError(err, 'active', authDispatch);
                console.log(err);
            }
        }
        ))
        return images
    }
    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (!selectedFile.length && !editProduct.name && !editProduct.description && !editProduct.tax_percentage && !editProduct.brand_id && !editProduct.category_id && !editProduct.subcategory_id && !editProduct.quantity && !editProduct.price) {
            setSelectedFileErr(`${language_data?.[authState.lang]?.common_image}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            setNameErr(`${language_data?.[authState.lang]?.common_name}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            setDescriptionErr(`${language_data?.[authState.lang]?.common_description}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            setBrandErr(`${language_data?.[authState.lang]?.common_brand}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            setTaxErr(`${language_data?.[authState.lang]?.common_tax}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            setCategoryErr(`${language_data?.[authState.lang]?.common_category}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            setSubcategoryErr(`${language_data?.[authState.lang]?.common_sub_category}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            setQuantityErr(`${language_data?.[authState.lang]?.common_quantity}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            setPriceErr(`${language_data?.[authState.lang]?.common_price}${language_data?.[authState.lang]?.common_is}${language_data?.[authState.lang]?.common_required}`)
            return
        }
        if (selectedFile.length === 0 && editProduct.images.length === 0) { setSelectedFileErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_select}${language_data?.[authState.lang]?.common_image}`); documentId('images'); return }
        if (!editProduct.name.trim()) { documentId('productName'); setNameErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_provide}${language_data?.[authState.lang]?.common_name}`); return }
        if (!editProduct.description.trim()) { documentId('description'); setDescriptionErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_provide}${language_data?.[authState.lang]?.common_description}`); return }
        if (!editProduct.price) { documentId('price'); setPriceErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_add}${language_data?.[authState.lang]?.common_price}`); return }
        if (!Number(editProduct.price)) { documentId('price'); setPriceErr(`${language_data?.[authState.lang]?.common_only} ${language_data?.[authState.lang]?.common_use} ${language_data?.[authState.lang]?.common_number}${language_data?.[authState.lang]?.common_in}${language_data?.[authState.lang]?.common_price}`); return }
        if (!editProduct.tax_percentage) { documentId('tax_percentage'); setTaxErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_add}${language_data?.[authState.lang]?.common_tax}`); return }
        if (!Number(editProduct.tax_percentage)) { documentId('tax_percentage'); setTaxErr(`${language_data?.[authState.lang]?.common_only}${language_data?.[authState.lang]?.common_use}${language_data?.[authState.lang]?.common_number}${language_data?.[authState.lang]?.common_in}${language_data?.[authState.lang]?.common_tax}`); return }
        if (!editProduct.quantity) { documentId('quantity'); setQuantityErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_add}${language_data?.[authState.lang]?.common_quantity}`); return }
        if (!Number(editProduct.quantity)) { documentId('quantity'); setQuantityErr(`${language_data?.[authState.lang]?.common_only}${language_data?.[authState.lang]?.common_use}${language_data?.[authState.lang]?.common_number}${language_data?.[authState.lang]?.common_in}${language_data?.[authState.lang]?.common_quantity}`); return }
        if (!editProduct.brand_id.trim()) { documentId('brand_id'); setBrandErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_select}${language_data?.[authState.lang]?.common_brand}`); return }
        if (!editProduct.category_id.trim()) { documentId('category_id'); setCategoryErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_select}${language_data?.[authState.lang]?.common_category}`); return }
        if (!editProduct.subcategory_id.trim()) { documentId('subcategory_id'); setSubcategoryErr(`${language_data?.[authState.lang]?.common_please}${language_data?.[authState.lang]?.common_select}${language_data?.[authState.lang]?.common_sub_category}`); return }
        setLoading(true)
        const images = await uploadImages()
        // product_type:'WAERABLE_PRODUCT',
        // product_type:'ELECTRONICS',
        const variantData = variant.variant_type ? {
            variant_type: variant.variant_type,
            variant_value: variant.variant_type === 'COLOR'
                ? { label: variant.color, value: variant.color_name }
                : { label: variant.label, value: variant.value }
        } : {}

        const items = {
            _id: match?.params.id,
            name: editProduct.name,
            description: editProduct.description,
            brand_id: editProduct.brand_id,
            category_id: editProduct.category_id,
            subcategory_id: editProduct.subcategory_id,
            sub_subcategory_id: editProduct.sub_subcategory_id,
            images: [...images, ...editProduct.images],
            tax_percentage: Number(editProduct.tax_percentage),
            quantity: Number(editProduct.quantity),
            price: Number(editProduct.price),
            discount_percantage: Number(editProduct.discount_percantage),
            language: "ENGLISH",
            ...variantData
        }
        try {
            let res = await henceforthApi.Product.editProduct(items)
            // console.log(res);
            toastMessage(res.message)
            setEditProduct({
                name: "",
                description: "",
                brand_id: "",
                category_id: "",
                subcategory_id: "",
                sub_subcategory_id: '',
                images: [],
                quantity: '',
                price: "",
                discount_percantage: '',
                tax_percentage: '',
                sold: false,
                is_blocked: false,
                is_deleted: false,
                language: "ENGLISH"
            });
            // toastMessage(res.message)
            window.history.back();
        } catch (err: any) {
            // console.log(err);
            handleError(err, 'active', authDispatch);
        } finally {
            setLoading(false)
        }
    };

    const productDetails = async () => {
        setPageLoading(true)
        try {
            let productRes = (await henceforthApi.Product.getProductDetails(match?.params.id)).data

            setEditProduct({
                ...editProduct,
                name: productRes?.name,
                description: productRes?.description,
                brand_id: productRes?.brand_id?._id,
                category_id: productRes?.category_id?._id,
                subcategory_id: productRes?.subcategory_id?._id,
                sub_subcategory_id: productRes?.sub_subcategory_id?._id,
                tax_percentage: productRes?.tax_percentage,
                images: productRes?.images,
                quantity: productRes?.quantity,
                price: productRes?.price,
                discount_percantage: productRes?.discount_percantage,
            })
            if (productRes?.variant_type) {
                setVariant({
                    variant_type: productRes.variant_type,
                    color: productRes.variant_type === 'COLOR' ? productRes.variant_value?.label : '#000000',
                    color_name: productRes.variant_type === 'COLOR' ? productRes.variant_value?.value : '',
                    label: productRes.variant_type === 'SIZE' ? productRes.variant_value?.label : '',
                    value: productRes.variant_type === 'SIZE' ? productRes.variant_value?.value : '',
                })
            }
        } catch (err: any) {
            handleError(err, '', authDispatch);
            console.log(err.response);
        } finally {
            setPageLoading(false)
        }
    }
    useEffect(() => {
        productDetails()
    }, [])
    const imageRemove = (del: string, id: number) => {
        if (del) {
            editProduct.images.splice(id, 1)
            setEditProduct({
                ...editProduct,
            })
        } else {
            selectedFile.splice(id, 1)
            setSelectedFile([
                ...selectedFile,
            ])
        }
    }
    return (
        <Fragment>
            <BreadCrumb pathNameDeclare={breadCrumbPath} />
            <div className='page-spacing'>
                {!authState?.is_bank_added ? (
                    <section className='product-detail'>
                        <div className="container-fluid">
                            <div className="row justify-content-center">
                                <div className="col-md-6 mt-5">
                                    <div className="common-card text-center py-5">
                                        <div className="mb-4 text-warning">
                                            <i className="fa fa-exclamation-triangle fa-4x"></i>
                                        </div>
                                        <h4 className="mb-3">Bank Details Required</h4>
                                        <p className="text-muted mb-4">You need to add your bank details before you can edit products.</p>
                                        <Link to="/profile/bank-details" className="btn btn-theme px-5">
                                            <i className="fa fa-plus-circle me-1"></i> Add Bank Details Now
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                ) : (
                    pageLoading ? (
                        <div className='vh-100 d-flex justify-content-center py-5'>
                            <Spinner color={"text-success"} />
                        </div>
                    ) : (
                        <section className='product-detail'>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12 col-md-12">
                                        {/* Title  */}
                                        <div className="common-card">
                                            <div className="common-card-title">
                                                <h5>{language_data?.[authState.lang]?.common_edit} {language_data?.[authState.lang]?.common_product}</h5>
                                            </div>
                                            {/* Profile  */}
                                            <div className="common-card-content">
                                                <form onSubmit={handleSubmit}>

                                                    <div className="upload-fields-box mb-3">
                                                        {/* <label htmlFor="" className='fw-bolder mb-2'>{language_data?.[authState.lang]?.common_product} {language_data?.[authState.lang]?.common_images}</label> */}
                                                        <label className='fw-bolder mb-2'>
                                                            {language_data?.[authState.lang]?.common_product} {language_data?.[authState.lang]?.common_images}
                                                            <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                                                        </label>
                                                        {/* Upload image */}

                                                        <div className="product-edit-image d-flex gap-2 gap-md-4 gap-lg-5 flex-column flex-sm-row">
                                                            <div className="product-edit-upload">
                                                                <div className='upload-fields-box mb-3'>
                                                                    <div className='profile-edit-image mb-2 mx-0 product-edit-upload-image'>
                                                                        <div className='profile-edit-upload'>
                                                                            <input
                                                                                id="images"
                                                                                onChange={(e) => { setSelectedFileErr(''); handleFile(e) }}
                                                                                type="file"
                                                                                className={`form-control ${selectedFileErr ? 'is-invalid' : ''}`}
                                                                                accept='image/png,image/jpeg'
                                                                                multiple
                                                                            />
                                                                        </div>
                                                                        <img src={imageUpload} alt="img" className={` ${selectedFileErr ? 'border border-danger' : ''}`} />
                                                                    </div>
                                                                    <Errormessage phone={selectedFileErr} error={selectedFileErr} />
                                                                </div>
                                                            </div>
                                                            <div className='product-images-preview d-inline-flex gap-sm-4 gap-md-4 gap-lg-5 gap-3 flex-wrap flex-column flex-sm-row'>
                                                                {editProduct.images && editProduct.images.map((res, index: number) => {
                                                                    return (
                                                                        <div key={index} className='preview-image-box position-relative'>
                                                                            <img
                                                                                className="Product-Images border border-light"
                                                                                src={`${henceforthApi.API_FILE_ROOT_MEDIUM}${res}`} alt={res} />
                                                                            {editProduct.images[0] !== "" && <span key={Math.random()} className='preview-image-close ' onClick={() => imageRemove("del", index)}><i className='fa fa-close text-dark' style={{ cursor: 'pointer' }}></i> </span>}
                                                                        </div>
                                                                    )
                                                                })}
                                                                {Array.isArray(selectedFile) ? selectedFile.map((res, index: number) => {

                                                                    return (
                                                                        <div key={index} className='preview-image-box position-relative'><img
                                                                            className="Product-Images border border-light"
                                                                            src={URL.createObjectURL(res)} alt="img" />
                                                                            {<span key={Math.random()} className='preview-image-close ' onClick={() => imageRemove("", index)}><i className='fa fa-close text-dark' style={{ cursor: 'pointer' }}></i> </span>}
                                                                        </div>
                                                                    )
                                                                }) : ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p><small><strong>{language_data?.[authState.lang]?.common_note}:-</strong>{language_data?.[authState.lang]?.common_please_upload_only_jpg_and_png_format_only}.</small></p>
                                                    <div className='divider my-3'></div>
                                                    {/* Product Name  */}
                                                    {/* <Inputs.Input type='text' id="productName" error={nameErr} label={`${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_name}`} name='name' placeholder={`${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_name}`} value={editProduct.name} handleChange={handleChange} /> */}
                                                    <Inputs.Input
                                                        type='text'
                                                        id="productName"
                                                        error={nameErr}
                                                        label={
                                                            <>
                                                                {language_data?.[authState.lang]?.common_product} {language_data?.[authState.lang]?.common_name}
                                                                <span style={{ color: 'black', marginLeft: 4 }}>*</span>
                                                            </>
                                                        }
                                                        name='name'
                                                        placeholder='Product Name'
                                                        value={editProduct.name}
                                                        handleChange={handleChange}
                                                    />
                                                    {/* Product Description  */}
                                                    <Textarea error={descriptionErr} id="description" col={30} row={5} label={
                                                        <>
                                                            Product Description
                                                            <span style={{ color: 'black', marginLeft: 4 }}>*</span>
                                                        </>
                                                    } name='description' placeholder={`${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_description}`} value={editProduct.description} handleChange={handleChange} />
                                                    {/* Product Price  */}
                                                    <Inputs.Input type='text' id="price" error={priceErr} label={
                                                        <>
                                                            Product Price
                                                            <span style={{ color: 'black', marginLeft: 4 }}>*</span>
                                                        </>
                                                    } name='price' placeholder={`${language_data?.[authState.lang]?.common_price}`} value={editProduct.price} handleChange={handleChange} />
                                                    {/* Product tax  */}
                                                    <Inputs.Input type='text' error={taxErr} label={
                                                        <>
                                                            Tax %
                                                            <span style={{ color: 'black', marginLeft: 4 }}>*</span>
                                                        </>
                                                    } name='tax_percentage' placeholder={`${language_data?.[authState.lang]?.common_tax} ${language_data?.[authState.lang]?.common_percentage}`} value={editProduct.tax_percentage} handleChange={handleChange} />
                                                    {/* Quantity */}
                                                    <Inputs.Input type='number' id="quantity" error={quantityErr} label={
                                                        <>
                                                            Quantity
                                                            <span style={{ color: 'black', marginLeft: 4 }}>*</span>
                                                        </>
                                                    } name='quantity' placeholder={`${language_data?.[authState.lang]?.common_quantity}`} value={editProduct.quantity} handleChange={handleChange} />
                                                    {/* Brand  */}
                                                    <Select Array={brandDetails.brand} id="brand_id" error={brandErr} label={
                                                        <span className='fw-bolder'>
                                                            {language_data?.[authState.lang]?.common_brand}
                                                            <span style={{ color: 'black', marginLeft: 4 }}>*</span>
                                                        </span>
                                                    } firstSelect='Brand' name='brand_id' value={editProduct.brand_id} handleChange={handleChange} />
                                                    {/* Category-1  */}
                                                    <Select Array={brandDetails.category} id="category_id" error={categoryErr} label={
                                                        <span className='fw-bolder'>
                                                            {language_data?.[authState.lang]?.common_category_level} {language_data?.[authState.lang]?._1}
                                                            <span style={{ color: 'black', marginLeft: 4 }}>*</span>
                                                        </span>
                                                    } firstSelect='Category' name='category_id' value={editProduct.category_id} handleChange={handleChange} />
                                                    {/* Category-2  */}
                                                    <Select Array={subCategory} disabled={!editProduct.category_id} error={subCategoryErr} label={
                                                        <span className='fw-bolder'>
                                                            {language_data?.[authState.lang]?.common_category_level} {language_data?.[authState.lang]?._2}
                                                            <span style={{ color: 'black', marginLeft: 4 }}>*</span>
                                                        </span>
                                                    } firstSelect='SubCategory' name='subcategory_id' value={editProduct.subcategory_id} handleChange={handleChange} />
                                                    {/* Category-3  */}
                                                    <Select Array={subSubCategory} disabled={!editProduct.subcategory_id} label={`${language_data?.[authState.lang]?.common_category_level} ${language_data?.[authState.lang]?._3}`} firstSelect='Sub_SubCategory' name='sub_subcategory_id' value={editProduct.sub_subcategory_id} handleChange={handleChange} />
                                                    {/* Discount  */}
                                                    <Inputs.Input type='number' label={`${language_data?.[authState.lang]?.common_discount}`} name='discount_percantage' placeholder={`${language_data?.[authState.lang]?.common_enter} ${language_data?.[authState.lang]?.common_your} ${language_data?.[authState.lang]?.common_discount}}`} value={editProduct.discount_percantage} handleChange={handleChange} />
                                                    {/* <Select Array={commonArray?.discount} label='Discount' firstSelect='Discount' name='discount_percantage' value={editProduct.discount_percantage} handleChange={handleChange} /> */}
                                                    <div className="divider my-3"></div>

                                                    {/* ===== VARIANT SECTION ===== */}
                                                    <div className="row mb-2">
                                                        <div className="col-md-12">
                                                            <h5 className="fw-bolder mb-3">Variant (Optional)</h5>
                                                        </div>
                                                    </div>
                                                    <div className="row align-items-end g-3 mb-3">
                                                        <div className="col-12 col-md-4">
                                                            <label className="fw-bolder mb-2">Variant Type</label>
                                                            <select
                                                                className="form-select"
                                                                value={variant.variant_type}
                                                                onChange={(e) => setVariant({
                                                                    variant_type: e.target.value as VariantData['variant_type'],
                                                                    color: '#000000',
                                                                    color_name: '',
                                                                    label: '',
                                                                    value: ''
                                                                })}
                                                            >
                                                                <option value="">Select Variant Type</option>
                                                                <option value="COLOR">Color</option>
                                                                <option value="SIZE">Size</option>
                                                            </select>
                                                        </div>

                                                        {variant.variant_type === 'COLOR' && (
                                                            <>
                                                                <div className="col-12 col-md-4">
                                                                    <label className="fw-bolder mb-2">Color</label>
                                                                    <input
                                                                        type="color"
                                                                        className="form-control form-control-color w-100"
                                                                        style={{ height: '38px' }}
                                                                        value={variant.color}
                                                                        onChange={(e) => setVariant({ ...variant, color: e.target.value })}
                                                                    />
                                                                </div>
                                                                <div className="col-12 col-md-4">
                                                                    <label className="fw-bolder mb-2">Color Name</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="e.g. Red, Sky Blue"
                                                                        value={variant.color_name}
                                                                        onChange={(e) => setVariant({ ...variant, color_name: e.target.value })}
                                                                    />
                                                                </div>
                                                            </>
                                                        )}

                                                        {variant.variant_type === 'SIZE' && (
                                                            <>
                                                                <div className="col-12 col-md-4">
                                                                    <label className="fw-bolder mb-2">Label</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Small, Medium"
                                                                        value={variant.label}
                                                                        onChange={(e) => setVariant({ ...variant, label: e.target.value })}
                                                                    />
                                                                </div>
                                                                <div className="col-12 col-md-4">
                                                                    <label className="fw-bolder mb-2">Value</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="S, M, L"
                                                                        value={variant.value}
                                                                        onChange={(e) => setVariant({ ...variant, value: e.target.value })}
                                                                    />
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                    {/* Buttons  */}
                                                    <SaveCancelButton loading={loading} color="text-white" onClick={handleSubmit} />
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    )
                )}
            </div>
        </Fragment>
    )
}
export default EditProduct;